import React, { useEffect, useState } from "react";
import styles from "./LoginForm.module.css";
import { useNavigate } from "react-router-dom";
import { resetPassword, varifyResetToken } from "../../api/Api";

export const PasswordResetForm = () => {

    // ----------------------------------------------------- STATE AND HOOKS
    let token = localStorage.getItem("token");
    let resetToken = window.location.pathname.split("/")[2];

    const naviage = useNavigate();

    const [tokenCheck, setTokenCheck] = useState(null);

    const [newPassword, setNewPassword] = useState(null);
    const [confirmPassword, setConfirmPassword] = useState(null);

    useEffect(() =>{
        // checks reset token on first render
        if (tokenCheck === null) checkToken();
    },[])

    // ----------------------------------------------------- PRE-RENDER

    async function checkToken() {
        // checks validity of reset token

        console.log ("calling chekc toekn ", tokenCheck)

        await varifyResetToken(resetToken)
            .then((response) => {
                setTokenCheck(response);
                console.log("validity of token: ",response)
            })
            .catch((error) => {
                console.log("failed to check validity of reset token", error);
            })
    }

    const changeNewPassword = (event) => {
        // catches changes to new password
        setNewPassword(event.target.value);

    }

    const changeConfirmPassword = (event) => {
        // catches changes to confirm password
        setConfirmPassword(event.target.value);

    }

    function handleCancel() {
        // handles click to cancel button
        naviage("/");
    }

    async function handleSubmit() {
        // handles click to submit button

        if (newPassword !== confirmPassword) return;

        await resetPassword(confirmPassword, resetToken)
            .then(() =>{
                naviage("/");
                window.location.reload();
            })
            .catch((error) => {
                console.log("failed to reset password", error)
            })
    }
    // ----------------------------------------------------- RENDER

    if (tokenCheck === false) {
        return (
            <section className={styles.container}>
                <div className={styles.content}>
                    <img src="/assets/images/logo.png" className={styles.logo} />
                    <h1 className={styles.sectionHeader}>Reset Password</h1>
                        <div className={styles.form}>
                            <h1 className={styles.invalid}>Invalid request</h1>
                        </div>
                </div>
            </section>
        )
    }

    return (
        <section className={styles.container}>
            <div className={styles.content}>

                <img src="/assets/images/logo.png" className={styles.logo} />
                <h1 className={styles.sectionHeader}>Reset Password</h1>

                <form className={styles.form}>
                    <div className={styles.labelHeader}>
                        <h1 htmlFor="newpassword">
                            New Password
                        </h1>
                        <input type="password"
                            id="newpassword"
                            className={styles.inputBox}
                            onChange={changeNewPassword} />
                    </div>

                    <div className={styles.labelHeader}>
                        <h1 htmlFor="confirm">
                            Confirm Password
                        </h1>
                        <input type="password"
                            id="confirm"
                            className={styles.inputBox}
                            onChange={changeConfirmPassword} />
                    </div>

                    {confirmPassword !== null && confirmPassword !== newPassword ?
                        <div className={styles.failer}>Passwords do not match!</div>
                        :
                        null
                    }

                    <div className={styles.buttons}>
                        <button className={styles.cancelButton} onClick={handleCancel}>Cancel</button>
                        <button className={styles.submitButton} onClick={handleSubmit} type="button">Submit</button>
                    </div>
                </form>
            </div>
        </section>
    )
}